import React from "react";

// Background + Member Images
import bgTeam from "../../../images/bg/team-bg.png";
import noiseBg from "../../../images/team/noice-bg.png";

import img01 from "../../../images/team/img01.jpg";
import img02 from "../../../images/team/img02.jpg";
import img03 from "../../../images/team/img03.jpg";
import img04 from "../../../images/team/img04.jpg";
import img05 from "../../../images/team/img05.jpg";
import img06 from "../../../images/team/img06.jpg";
import img07 from "../../../images/team/img07.jpg";
import img08 from "../../../images/team/img08.jpg";
import rajesh from "../../../images/team/rajesh.jpg";
import samuel from "../../../images/team/samuel.png";
import abhishek from "../../../images/team/abhishek.jpg";

// Founders data
const teamMembers = [
  {
    name: "Rajesh T",
    role: "Co-Founder & Managing Director",
    img: rajesh,
    linkedin: "https://www.linkedin.com/"
  },
  {
    name: "Samuel M",
    role: "Co-Founder & Chief Strategy Officer",
    img: samuel,
    linkedin: "https://www.linkedin.com/"
  },
  {
    name: "Abhishek T",
    role: "Co-Founder",
    img: abhishek,
    linkedin: "https://www.linkedin.com/"
  },
];

const TeamSection: React.FC = () => {
  return (
    <section
      className="team pt-140 pb-150 bg_img"
      style={{ backgroundImage: `url(${bgTeam})` }}
    >
      <div className="container">
        <div className="sec-title sec-title-center text-center mb-45">
          <span className="sub-title mb-20">Leadership</span>
          <h2 className="title title-line_height">Meet Our Founders</h2>
          <p style={{ color: "rgba(255,255,255,0.7)", marginTop: "20px", maxWidth: "600px", margin: "20px auto 0" }}>
            Visionaries driving innovation and positive change through technology
          </p>
        </div>

        {/* Centered row for 3 founders */}
        <div className="row mt-none-55 justify-content-center">
          {teamMembers.map((member, i) => (
            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mt-55"
              key={i}
            >
              <div className="xb-team-item xb-border">
                <div className="xb-item--img">
                  <img src={member.img} alt={member.name} />
                </div>

                <div className="xb-item--holder ul_li_between">
                  <div className="xb-item--author">
                    <h2 className="xb-item--name">{member.name}</h2>
                    <span className="xb-item--desig">{member.role}</span>
                  </div>
                  <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="xb-item--social xb-border">
                    <i className="fa-brands fa-linkedin-in"></i>
                  </a>
                </div>

                <div className="xb-bg">
                  <img src={noiseBg} alt="background texture" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
